import React from 'react';
import NewProfileView from '../../../components/ProfileViewNew/index';
export default function CandidateProfileView() {

  return (
      <NewProfileView/>
  );
}
